import template from './acris-faq-group-detail.html.twig';
import './acris-faq-group-detail.scss';

const { Component, Context } = Shopware;
const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('acris-faq-group-detail', {
    template,

    inject: ['repositoryFactory', 'context', 'acl'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    data() {
        return {
            item: null,
            isLoading: false,
            processSuccess: false,
            repository: null,
            isSaveSuccessful: false,
            // assignedFaqs: null
            assignedFaqs: [],
            page: 1,
            limit: 25,
            total: 0,
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    created() {
        this.createdComponent();
    },

    computed: {
        productContext() {
            return { ...Shopware.Context.api, inheritance: true }
        },

        productCriteria() {
            const criteria = new Criteria(1, 25);
            criteria.addAssociation('options.group');

            return criteria;
        },

        displayOptions() {
            return [
                { label: this.$tc('acris-faq-group.detail.fieldSelectOptionHide'), value: 'hide' },
                { label: this.$tc('acris-faq-group.detail.fieldSelectOptionShowAbove'), value: 'showAbove' }
            ]
        },

        displayFoldableOptions() {
            return [
                { label: this.$tc('acris-faq-group.detail.optionDisplayFoldablePluginConfig'), value: 'config' },
                { label: this.$tc('acris-faq-group.detail.optionDisplayFoldableNotFoldable'), value: 'notFoldable' },
                { label: this.$tc('acris-faq-group.detail.optionDisplayFoldableFolded'), value: 'folded' },
                { label: this.$tc('acris-faq-group.detail.optionDisplayFoldableUnFolded'), value: 'unFolded' },
            ]
        },

        faqGroupCriteria() {
            const criteria = new Criteria(this.page, this.limit);
            criteria.addAssociation('productStreams');
            criteria.addAssociation('faqs');
            criteria.addAssociation('categories');
            criteria.addAssociation('salesChannels');
            criteria.addAssociation('rules');
            criteria.addAssociation('products');
            criteria.addAssociation('products.options');
            criteria.addAssociation('products.options.group');

            return criteria
        },

        faqColumns() {
            return this.getFaqColumnsColumns();
        },

        cmsPageDisplayTypeOptions() {
            return [
                { value: 'all', label: this.$tc('acris-faq-group.detail.optionDisplayTypeAll') },
                { value: 'faqDetail', label: this.$tc('acris-faq-group.detail.optionDisplayTypeFaqDetail') },
            ]
        },

        optionsGroupDisplay() {
            return [
                { value: "belowListing", label: this.$tc('acris-faq-group.detail.fieldTitleLabelCategoriesDisplayOptionBelow') },
                { value: "cmsElement", label: this.$tc('acris-faq-group.detail.fieldTitleLabelCategoriesDisplayOptionElement') },
            ];
        },

        faqRepository() {
            return this.repositoryFactory.create('acris_faq');
        },
    },

    methods: {
        async createdComponent() {
            this.repository = this.repositoryFactory.create('acris_faq_group');
            this.getEntity();
        },

        getEntity() {
            this.repository
                .get(this.$route.params.id, Shopware.Context.api, this.faqGroupCriteria)
                .then((entity) => {
                    this.item = entity;
                    this.getAssignedFaqs(entity.id);
                });
        },

        onClickSave() {
            const titleSaveError = this.$tc('acris-faq-group.detail.titleSaveError');
            const messageSaveError = this.$tc('acris-faq-group.detail.messageSaveError');
            const titleSaveSuccess = this.$tc('acris-faq-group.detail.titleSaveSuccess');
            const messageSaveSuccess = this.$tc('acris-faq-group.detail.messageSaveSuccess');

            this.isSaveSuccessful = false;
            this.isLoading = true;

            this.repository
                .save(this.item, Shopware.Context.api)
                .then(() => {
                    this.getEntity();
                    this.processSuccess = true;
                    this.createNotificationSuccess({
                        title: titleSaveSuccess,
                        message: messageSaveSuccess
                    });
                }).catch(() => {
                    this.createNotificationError({
                        title: titleSaveError,
                        message: messageSaveError
                    });
                });

            this.isLoading = false;
        },

        saveFinish() {
            this.processSuccess = false;
        },

        getFaqColumnsColumns() {
            return [{
                property: 'internalName',
                label: this.$tc('acris-faq.list.columnInternalName'),
                routerLink: 'acris.faq.detail',
                disabled: true,
            }, {
                property: 'active',
                label: this.$tc('acris-faq.list.columnActive'),
                inlineEdit: 'boolean',
            }, {
                property: 'priority',
                label: this.$tc('acris-faq.list.columnPriority'),
                inlineEdit: 'number',
            }, {
                property: 'name',
                label: this.$tc('acris-faq.list.columnName'),
                routerLink: 'acris.faq.detail',
                multiLine: true,
                disabled: true,
            }, {
                property: 'description',
                label: this.$tc('acris-faq.list.columnDescription'),
                routerLink: 'acris.faq.detail',
                multiLine: true,
                disabled: true,
            }];
        },

        getAssignedFaqs(id) {
            this.isLoading = true;

            const faqCriteria = new Criteria();
            faqCriteria.addFilter(Criteria.equals('groups.id', id));
            faqCriteria.addSorting(Criteria.sort('priority', 'DESC'));
            faqCriteria.addSorting(Criteria.sort('internalName', 'ASC'));

            return this.faqRepository.search(faqCriteria, Context.api).then((response) => {
                this.assignedFaqs = response;
                this.total = response.total;
                this.isLoading = false;
                return Promise.resolve();
            });
        },

        getCleanText(description) {
            if (description) {
                const text = description.replace(/<\/?[^>]+(>|$)/g, '');
                return text.replace(/&(nbsp|amp|quot|lt|gt);/g, ' ');
            }
            return '';
        },

        onSaveInlineEdit(item) {
            if (item) {
                const titleSaveSuccess = this.$tc('acris-faq.detail.titleSaveSuccess');
                const messageSaveSuccess = this.$tc('acris-faq.detail.messageSaveSuccess');

                return this.faqRepository.save(item, Shopware.Context.api).then(() => {
                    this.createNotificationSuccess({
                        title: titleSaveSuccess,
                        message: messageSaveSuccess
                    });
                    this.$refs.faqGrid.load();
                });
            }
        },

        onChangeLanguage() {
            this.getEntity();
        },

        onSalesChannelChange(newSalesChannels) {
            this.item.salesChannels = newSalesChannels;
        },

        onRulesChange(newRules) {
            this.item.rules = newRules;
        },

        onProductStreamChange(newProductStreams) {
            this.item.productStreams = newProductStreams;
        },

        onItemProductChange(newItemProducts) {
            this.item.products = newItemProducts;
        },

        onCreateLayout() {
            this.$router.push({
                name: 'sw.cms.create'
            });
        },

        updateCmsPageBefore(cmsPage) {
            this.item.cmsPageBeforeId = cmsPage?.id;
            this.item.cmsPageBeforeVersionId = cmsPage?.versionId;
        },

        updateCmsPageAfter(cmsPage) {
            this.item.cmsPageAfterId = cmsPage?.id;
            this.item.cmsPageAfterVersionId = cmsPage?.versionId;
        },

        //
        //
        // onCancelInlineEdit(item){
        //     console.log("canceled");
        //     this.$refs.faqGrid.load();
        // }
    }
});
